"use client";

import { Heading, Paragraph } from "@/components/ui/typography";

function ErrorPage({ error }) {
  return (
    <>
      <div className="flex items-center justify-center py-8 min-h-screen">
        <div className="flex flex-col items-center">
          <Heading variant="h2" className="text-primary">
            Oops! {error.message}
          </Heading>
          <Paragraph>
            Sorry, we are facing some issues. Please try again later.
          </Paragraph>
        </div>
      </div>
    </>
  );
}

export default ErrorPage;
